import(/* webpackMode: "eager" */ "/opt/stpi-client/src/app/(index)/public/privacy_policy/page.tsx");
